import SettingsNavItem from './SettingsNavItem';

export default SettingsNavItem;
